// @ts-nocheck
import React from 'react'
import { Column } from 'react-table'
import { EstrattiContoSubnetActionsCell } from './EstrattiContoSubnetActionsCell'
import { UserCustomHeader } from './UserCustomHeader'
import { formatCurrency } from '../../../../lib/helpers/formatters'

const estrattiContoColumns: ReadonlyArray<Column<any>> = [
  {
    Header: props => (
      <UserCustomHeader
        tableProps={props}
        title="Agente"
        className="min-w-125px"
      />
    ),
    accessor: 'agent',
    Cell: ({ ...props }) => {
      return `${props.data[props.row.index]?.username} - ${props.data[props.row.index]?.first_name} ${props.data[props.row.index]?.last_name}`
    }
  },
  {
    Header: props => (
      <UserCustomHeader
        tableProps={props}
        title="Contratto"
        className="min-w-125px"
      />
    ),
    accessor: 'contract',
    Cell: ({ ...props }) => {
      return (
        props.data[props.row.index]?.fiscalPositions &&
        props.data[props.row.index]?.fiscalPositions?.name
      )
    }
  },
  {
    Header: props => (
      <UserCustomHeader
        tableProps={props}
        title="Ruolo"
        className="min-w-125px"
      />
    ),
    accessor: 'role',
    Cell: ({ ...props }) => {
      return (
        props.data[props.row.index]?.roles &&
        props.data[props.row.index]?.roles?.name
      )
    }
  },
  {
    Header: props => (
      <UserCustomHeader
        tableProps={props}
        title="Imponibile"
        className="min-w-125px"
      />
    ),
    accessor: 'taxable',
    Cell: ({ ...props }) => {
      return formatCurrency(props.data[props.row.index]?.taxable || 0)
    }
  },
  {
    Header: props => (
      <UserCustomHeader
        tableProps={props}
        title="Da fatturare"
        className="min-w-125px"
      />
    ),
    accessor: 'net',
    Cell: ({ ...props }) => {
      return formatCurrency(props.data[props.row.index]?.net || 0)
    }
  },
  {
    Header: props => (
      <UserCustomHeader
        tableProps={props}
        title="Azioni"
        className="text-end min-w-100px"
      />
    ),
    id: 'actions',
    Cell: ({ ...props }) =>
      props.data[props.row.index]?.status ? (
        <EstrattiContoSubnetActionsCell user={props.data[props.row.index]} />
      ) : (
        <></>
      )
  }
]

export { estrattiContoColumns }
